module.exports = __webpack_public_path__ + "static/media/sc18.23.d67479bb.mp4";